(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-template"]) return;
  try {
    
//Image Zoom
var imgContainerEl = document.querySelector('.product__main-photos');

if( typeof imgContainerEl != "undefined" ) {
  //Desktop Zoom
  if( window.innerWidth >= 767 ) {

    imgContainerEl.addEventListener("mousemove", function(e) {
      var el = e.target,
          elType = el.tagName;

      if( elType === 'IMG' ) {
        var parentEl = el.parentElement,
            isBG = parentEl.classList.contains('zoomed')? 1 : 0;
        if( !isBG ) {
          var curSrc = el.currentSrc,
              imgSrc = el.dataset.photoswipeSrc;
          if( imgSrc ) {
            parentEl.classList.add('loading');

            //load init image first
            parentEl.style.backgroundImage = "url('"+curSrc+"')";

            //replace with bigger image
            var img = new Image();
            img.onload = function() {
              //add scaling zoom
              if( this.width < 900 ) {
                parentEl.classList.add('scale');
              }

              parentEl.style.backgroundImage = "url('"+imgSrc+"')";
              parentEl.classList.remove('loading');
              parentEl.classList.add('zoomed');
            }
            img.src = imgSrc;
          }
        }
  
        //zoom image    
        e.offsetX ? offsetX = e.offsetX : offsetX = e.touches[0].pageX
        e.offsetY ? offsetY = e.offsetY : offsetX = e.touches[0].pageX
      
        x = offsetX/parentEl.offsetWidth*100
        y = offsetY/parentEl.offsetHeight*100
        parentEl.style.backgroundPosition = x + '% ' + y + '%';
      }
    });
  }
}

  } catch(e) { console.error(e); }
})();
})();
